import { motion } from "framer-motion";
import { fadeUp, staggerContainer, VIEWPORT_SM } from "./primitives";
import { useLanguage } from "@/i18n/LanguageContext";

// Real press/partner marks only — supplied by the founder. The bar renders
// nothing while this list is empty; never fill it with placeholder logos.
const TRUST_LOGOS = [
  // { src: "/images/press/example.svg", alt: "Example", href: "https://…" },
];

export const TrustBar = () => {
  const { t } = useLanguage();
  if (TRUST_LOGOS.length === 0) return null;

  return (
    <motion.section
      data-testid="trust-bar"
      initial="hidden"
      whileInView="visible"
      viewport={VIEWPORT_SM}
      variants={staggerContainer}
      className="border-y border-ink/5 bg-surface-muted py-10 px-6"
    >
      <p className="mb-8 text-center text-[11px] tracking-[0.35em] uppercase text-ink-subtle">
        {t("trust.eyebrow")}
      </p>
      <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-14 gap-y-8">
        {TRUST_LOGOS.map((logo) => {
          const img = (
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              className="h-7 w-auto object-contain opacity-50 grayscale transition-all duration-300 hover:opacity-90 hover:grayscale-0"
            />
          );
          return (
            <motion.span key={logo.src} variants={fadeUp}>
              {logo.href ? (
                <a href={logo.href} target="_blank" rel="noopener noreferrer">
                  {img}
                </a>
              ) : (
                img
              )}
            </motion.span>
          );
        })}
      </div>
    </motion.section>
  );
};

export default TrustBar;
